"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

/**
 * Devuelve la ruta actual incluyendo el hash (`/#sobre-mi`, `/asociacion-equilibrio#contacto`),
 * que `usePathname()` no expone. Necesario para marcar como activos los enlaces de ancla.
 *
 * El hash solo existe en cliente: arranca como "" (coincide con el SSR para evitar
 * desajustes de hidratación) y se sincroniza tras montar y en cada `hashchange`.
 */
export const useCurrentPath = (): string => {
	const pathname = usePathname();
	const [hash, setHash] = useState("");

	useEffect(() => {
		const syncHash = () => setHash(window.location.hash);
		syncHash();
		window.addEventListener("hashchange", syncHash);
		return () => window.removeEventListener("hashchange", syncHash);
	}, [pathname]);

	return pathname + hash;
};
